<template>
  <div>
    <span class="d-flex mx-4 my-4">
      <v-btn
          large
          color="secondary"
          class="mt-1 py-6"
          @click="navigateBack()">
        <v-icon large>mdi-chevron-left</v-icon>
      </v-btn>
      <v-spacer />
      <div class="mt-2">
        <div class="d-flex flex-wrap">
          <v-icon class="text-h4">mdi-barn</v-icon>
          <span class="text-h5 ml-2 mt-2">Farm: {{settings.currentFarm}}</span>
        </div>
      </div>
      <v-spacer />
      <v-btn
          fab
          color="secondary"
          @click="addGroup()">
        <v-icon class="text-h4">mdi-playlist-plus</v-icon>
      </v-btn>
    </span>
    <div class="d-flex flex-wrap justify-center">
        <v-card v-if="healthBleedGroups.length === 0"
          class="ma-2 pa-10"
          width="356"
          color="cardbackground" 
        >
          No Health Groups found.
        </v-card>
        <v-card v-for="(item, index) in healthBleedGroups" :key="item.groupName"
          class="ma-2"
          max-width="356"
          color="cardbackground" 
        >
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text-h6 mb-0">
                <span>
                  <v-btn icon @click="toggleCardDetails(index)">
                    <v-icon>{{ showDetail[index] ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                  </v-btn>
                </span>
                 <a @click="toggleCardDetails(index)">{{ item.groupName }}</a>
              </v-list-item-title>
              <v-list-item-subtitle class="ml-9">
                Samples: {{getCurrentSampleCountForCollection(item)}} / {{ getRequiredSampleCountForCollection(item) }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-card-actions class="pb-4">
            <v-btn
              x-large
              color="secondary"
              class="ml-1 pl-4 pr-6"
              @click="goToHealthSamplesPage(item)">
              <v-icon large>mdi-medical-bag</v-icon>
              <span class="ml-1 mt-1">Bleed</span>
            </v-btn>
            <v-spacer />
            <v-btn
                fab
                class="ml-2"
                color="primary" 
                :disabled="isUploadDisabled(item)"
                @click="selectedGroup=item.groupName; showUploadDialog = true">
              <v-icon>mdi-upload</v-icon>
            </v-btn>

            <v-btn
              fab
              color="success"
              @click="editGroup(item)">
              <v-icon>mdi-pencil-outline</v-icon>
            </v-btn>

            <v-btn
              fab
              color="secondary"
              @click="confirmDeleteGroup(item)">
              <v-icon>mdi-delete-outline</v-icon>
            </v-btn>
          </v-card-actions>
          <v-expand-transition>
            <div v-show="showDetail[index]">
              <v-divider></v-divider>
              <v-card-text>
                <div class="primary--text text-subtitle-1">Details</div>
                <ul class="side-by-side">
                  <li><b>Farm:</b> {{item.farm}}</li>
                  <li><b>Type:</b> {{item.type}}</li>
                  <li><b>Planned:</b> {{ item.plannedCollectionDate ?? 'Unknown' }}</li>
                  <li><b>Hatch:</b> {{item.hatch}}</li>
                  <li><b>Set-up:</b><br /> {{item.setup}}</li>
                  <li><b>Batches:</b> {{getBatchNums(item.batches) }}</li>
                  <li><b>Samples:</b> {{ getCurrentSampleCountForCollection(item) }} / {{ getRequiredSampleCountForCollection(item) }}</li>
                </ul>
                <div style="clear: both;"></div>
              </v-card-text>
            </div>
          </v-expand-transition>
        </v-card>
    </div>

    <v-dialog v-model="showModifyDialog" persistent max-width="420px">
      <v-card color="cardbackground">
        <v-card-title>
          <div class="headline" v-if="editItem.oldGroupName === null">Create Group</div>
          <div class="headline" v-else>Modify Group</div>
        </v-card-title>
        <v-card-text class="py-0">
          <v-form ref="form" v-model="validForm">
            <div
              class="d-flex flex-wrap overflow-y-auto"
              style="height: 300px;">
                <v-col cols="6">
                  <v-text-field
                    class="pa-0"
                    disabled
                    v-model="editItem.farm"
                    label="Farm"
                  />
                </v-col>
                <v-col cols="6">
                  <v-select
                    class="pa-0"
                    v-model="editItem.hatch"
                    label="Hatch"
                    :items="[ 'N/A', '0', '1', '2', '3', '4', '5', '6', '7']"
                    :rules="[rules.required]"
                  />
                </v-col>
                <v-col cols="6">
                  <v-select
                    class="pa-0"
                    v-model="editItem.type"
                    :disabled="editItem.batches != null && editItem.batches.length > 0"
                    label="Type"
                    :items="this.collectionTypes"
                    :rules="[rules.required]"
                  />
                </v-col>
                <v-col cols="6">
                  <v-select
                    class="pa-0"
                    :disabled="editItem.oldGroupName != null"
                    v-model="editItem.setup"
                    label="Set Up"
                    :items="[ 'Control Plate', 'Full Plate / Tube']"
                    :rules="[rules.required]"
                  />
                </v-col>
                <v-col cols="12">
                  <v-select
                    class="pa-0"
                    :disabled="getCurrentSampleCountForCollection(editItem) > 0"
                    v-model="editItem.batches"
                    :items="batchList"
                    item-text="batchNum"
                    item-value="id"
                    label="Batch ID"
                    return-object
                    clearable
                    multiple
                  >
                    <template v-slot:item="data">
                        <v-list-item-content @click="toggleBatchSelection(data.item)">
                          <v-list-item-title class="d-flex">
                            <div style="font-size:20px" class="mr-2">
                              {{ isBatchSelected(data.item) ? '☑' : '☐' }}
                            </div>
                            <div style="margin-top:3px">{{ data.item.batchNum }}</div>
                          </v-list-item-title>
                          <v-list-item-subtitle class="ma-0 pa-0">
                            <table>
                              <tr>
                                <td><strong>Planned:&nbsp;</strong></td>
                                <td><span v-html="boldValues(data.item.plannedCollectionDate ?? 'Unknown')"></span></td>
                              </tr>
                              <tr>
                                <td><strong>Flock: </strong></td>
                                <td><span v-html="boldValues(data.item.flock)"></span></td>
                              </tr>
                              <tr>
                                <td><strong>Locations: </strong></td>
                                <td><span v-html="boldValues(data.item.location)"></span></td>
                              </tr>
                              <tr>
                                <td><strong>Lines:&nbsp;</strong></td>
                                <td><span v-html="boldValues(data.item.line)"></span></td>
                              </tr>
                              <tr>
                                <td><strong>Age (weeks):&nbsp;</strong></td>
                                <td><span v-html="boldValues(data.item.age)"></span></td>
                              </tr>
                              <tr>
                                <td><strong>Samples: </strong></td>
                                <td><span v-html="boldValues(`${data.item.sampleCount}`)"></span></td>
                              </tr>
                            </table>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                    </template>
                  </v-select>
                </v-col>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions class="py-0">
          <v-spacer />
          <v-btn
            color="primary"
            class="white--text mb-3"
            :disabled="!validForm || !saveEnabled"
            @click="saveClicked()">
            Save
          </v-btn>
          <v-btn
            color="secondary"
            class="mb-3 mr-4"
            @click="closeModifyDialog()">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showUploadDialog" persistent max-width="350">
      <v-card color="cardbackground">
        <v-card-title class="text-h5">Confirm Upload</v-card-title>
        <v-card-text>
          <div>Upload this Health Bleed Group?</div>
          <ul class="mt-2">
              {{ selectedGroup }}
          </ul>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" class="white--text" @click="uploadHealthBleedGroup()">Upload</v-btn>
          <v-btn color="secondary" @click="showUploadDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showModifyConfirmDialog" persistent max-width="350">
      <v-card color="cardbackground">
        <v-card-title class="text-h5">Save Group Changes?</v-card-title>
        <v-card-text class="d-flex">
          <div>
            <div class="primary--text text-subtitle-1">Old</div>
            <ul class="pl-4 mr-2" style="min-width:140px; border-top:1px solid">
              <li><b>Farm:</b> {{oldModifyItem.farm}}</li>
              <li><b>Type:</b> {{oldModifyItem.type}}</li>
              <li><b>Hatch:</b> {{oldModifyItem.hatch}}</li>
              <li><b>Set-up:</b> {{oldModifyItem.setup}}</li>
              <li><b>Batches:</b> {{getBatchNums(oldModifyItem.batches) }}</li>
            </ul>
          </div>
          <v-spacer />
          <div class="ml-2">
            <div class="primary--text text-subtitle-1">New</div>
            <ul class="pl-4" style="min-width:140px; border-top:1px solid">
              <li :style="changeBackgroundColor(editItem.farm != oldModifyItem.farm)"><b>Farm:</b> {{editItem.farm}}</li>
              <li :style="changeBackgroundColor(editItem.type != oldModifyItem.type)"><b>Type:</b> {{editItem.type}}</li>
              <li :style="changeBackgroundColor(editItem.hatch != oldModifyItem.hatch)"><b>Hatch:</b> {{editItem.hatch}}</li>
              <li :style="changeBackgroundColor(editItem.setup != oldModifyItem.setup)"><b>Set-up:</b> {{editItem.setup}}</li>
              <li :style="changeBackgroundColor(getBatchNums(editItem.batches) != getBatchNums(oldModifyItem.batches))"><b>Batches:</b> {{getBatchNums(editItem.batches) }}</li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" class="white--text" @click="saveGroup()">Save</v-btn>
          <v-btn color="secondary" @click="showModifyConfirmDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDeleteDialog" persistent max-width="350">
      <v-card color="cardbackground">
        <v-card-title class="text-h5">Confirm Delete</v-card-title>
        <v-card-text>Is it okay to delete {{ groupToDelete }}?</v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" class="white--text" @click="deleteGroup()">Yes</v-btn>
          <v-btn color="secondary" @click="showDeleteDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="isBusy">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import OfflineStorage from '../offlineStorage'
import { mapState } from 'vuex'
import gbaApi from '../api/gbaApi'

// Mapping of QAP reasons to GBA types. This is used to filter
// the batch list based on the selected type. If the QAP reason
// is not in the mapping, it will be considered as 'Other'.
// Note: This is exported for use in the LocalStorage page.
export const REASON_MAPPING = [
  // {qapReason: "Monitoring - Routine Flock",  gbaType: "ALV"},
  {qapReason: "Monitoring - Routine ALV",  gbaType: "ALV"},
  {qapReason: "NPIP (Re)Qualification", gbaType: "Certification"},
  {qapReason: "Export", gbaType: "Export"}
];

export default {
  data() {
    return {
      editItem: {},
      groupToDelete: null,
      healthBleedGroups: [],
      isBusy: false,
      rules: [],
      selectedGroup: null,
      showDeleteDialog: false,
      showDetail: [],
      showModifyConfirmDialog: false,
      showModifyDialog: false,
      showUploadDialog: false,
      archivedHealthBleedGroups: [],
      validForm: true
    }
  },

  async created() {
    try {
      this.rules = { ...this.$root.validationRules };

      this.archivedHealthBleedGroups = await OfflineStorage.getItem('archivedHealthBleedGroups');
      if (this.archivedHealthBleedGroups == null) this.archivedHealthBleedGroups = [];
      else await this.removeOldHealthBleedGroups();  
        
      this.healthBleedGroups = await OfflineStorage.getItem('healthBleedGroups');
      if (this.healthBleedGroups == null) this.healthBleedGroups = [];

      if (this.settings.currentFarm == null) {
        this.$root.showNoticeWarning(
          'Please set the default farm. This can be done from the Settings page.'
        );
      }
    } catch(error) {
      this.$root.showNoticeError(error.message);
    }
  },

  computed: {
    ...mapState(['settings', 'isOnline']),
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    batchList() {
      const farmBatchInfo = this.settings.farmBatchInfo;
      if (!farmBatchInfo) return [];

      const selectedType = this.editItem.type;
      const uniqueFarmBatchInfoMap = new Map();

      farmBatchInfo.forEach(info => {
        let filteredSamples = info.samples;

        if (selectedType == 'Other') {
          filteredSamples = info.samples.filter(sample => {
            const mapping = REASON_MAPPING.find(item => item.qapReason === sample.reason);
            return !mapping; //Other will be any other QAP reason that is not in the REASON_MAPPING
          });
        } else if (selectedType) {
          filteredSamples = info.samples.filter(sample => {
            const mapping = REASON_MAPPING.find(item => item.qapReason === sample.reason);
            return mapping && mapping.gbaType === selectedType;
          });
        }

        if (filteredSamples.length > 0) {
          const uniqueKey = `${info.batchNum}`;
          if (!uniqueFarmBatchInfoMap.has(uniqueKey)) {
            uniqueFarmBatchInfoMap.set(uniqueKey, this.getUniqueValues(info.batchNum, info.plannedCollectionDate, info.samples));
          }
        }
      });

      return Array.from(uniqueFarmBatchInfoMap.values());
    },
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    oldModifyItem() {
      var oldItem = this.healthBleedGroups.find(x => x.groupName === this.editItem.oldGroupName);
      return oldItem == null ? {} : oldItem;
    },
    collectionTypes() {
      const farmBatchInfo = this.settings.farmBatchInfo;
      if (farmBatchInfo == null) return [];

      const mappedReasons = new Set();

      farmBatchInfo.forEach(b => {
        b.samples.forEach(s => {
          const mapping = REASON_MAPPING.find(item => item.qapReason === s.reason);
          const mappedReason = mapping ? mapping.gbaType : 'Other'; // Use mapped value or 'Other' if not found
          if (mappedReason) {
            mappedReasons.add(mappedReason); // Add to Set for uniqueness
          }
        });
      });

      return Array.from(mappedReasons); 
    },
    saveEnabled() {
      const item = this.editItem;
      if (item.farm != null &&
          item.type != null &&
          item.hatch != null &&
          (item.batches != null && item.batches.length > 0)
        )
      {
        return true;
      }
      return false;
    }
  },

  methods: {
    boldValues(values) {
      return values.split(',').map(value => `<u><b>${value.trim()}</b></u>`).join(', ');
    },
    getBatchNums(batches) {
      if (batches == null) return '';
      var x = batches.map(b => b.batchNum).join(', ');
      return x;
    },
    getCurrentSampleCountForCollection(item) {
      if (item.wells == null) return 0;
      return item.wells.length;
    },
    getRequiredSampleCountForCollection(item) {
      if (item.batches == null) return 0;
      const sampleCount = item.batches.reduce((sum, b) => sum + b.sampleCount, 0);
      return sampleCount;
    },
    getUniqueValues(batchNum, plannedCollectionDate, samples) {
      const uniqueLines = new Set();
      const uniqueHouses = new Set();
      const uniqueLocations = new Set();
      const uniqueAges = new Set();
      const uniqueFlocks = new Set();

      samples.forEach(sample => {
        sample.flocks.split(',').forEach(flock => uniqueFlocks.add(flock.trim()));
        sample.lines.split(',').forEach(line => uniqueLines.add(line.trim()));
        uniqueHouses.add(sample.house);
        uniqueLocations.add(sample.location);
        uniqueAges.add(sample.age);
      });

      var values = {
        batchNum: batchNum,
        plannedCollectionDate: plannedCollectionDate,
        flock: Array.from(uniqueFlocks).join(', '),
        line: Array.from(uniqueLines).join(', '),
        house: Array.from(uniqueHouses).join(', '),
        location: Array.from(uniqueLocations).join(', '),
        age: Array.from(uniqueAges).join(', '),
        sampleCount: samples.length
      };

      return values;
    },
    isBatchSelected(batch) {
      if (this.editItem.batches == null) return false;
      return this.editItem.batches.some(b => b.batchNum === batch.batchNum);
    },
    addGroup() {
      this.editItem =
      {
        oldGroupName: null,
        farm: this.settings.currentFarm,
        type: null,
        hatch: null,
        batches: null,
        wells: []
      };
      this.showModifyDialog = true;
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
    changeBackgroundColor(isChanged) {
      if (!isChanged) return '';
      if (this.$vuetify.theme.dark) 
        return 'background-color: gray';
      else
        return 'background-color:yellow';
    },
    closeModifyDialog() {
      this.showModifyDialog = false;
      this.showModifyConfirmDialog = false;
    },
    confirmDeleteGroup(item) {
      this.showDeleteDialog = true;
      this.groupToDelete = item.groupName;
    },
    daysDiff(firstDate, secondDate) {
      const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
      return diffDays;
    },
    async deleteGroup() {
      try {
        //* Find group to delete.
        const index = this.healthBleedGroups.findIndex(x => x.groupName === this.groupToDelete);
        
        //* Add group to archived groups.
        this.healthBleedGroups[index].deleteDate = new Date();
        this.archivedHealthBleedGroups.push(this.healthBleedGroups[index]);
        await OfflineStorage.setItem('archivedHealthBleedGroups', this.archivedHealthBleedGroups);

        //* Remove group from active groups.
        this.healthBleedGroups.splice(index, 1);
        await OfflineStorage.setItem('healthBleedGroups', this.healthBleedGroups);

        this.$root.showNoticeSuccess('Group deleted successfully.');
        this.showDeleteDialog = false;
      } catch (error) {
        this.$root.showNoticeError(error.message);
      }
    },
    editGroup(item) {
      this.editItem = JSON.parse(JSON.stringify(item));
      this.editItem.oldGroupName = this.editItem.groupName;
      this.showModifyDialog = true;
      setTimeout(() => this.$refs.form.validate(), 100);
    },
    goToHealthSamplesPage(item) {
        this.$router.push({ path: `/healthPlates?groupName=${item.groupName}&type=${item.setup}` });
    },
    isUploadDisabled(item) {
      if (!this.isOnline) return true;
      if (item.wells == null) return true;
      if (item.wells.length === 0) return true;
      return false;
    },
    navigateBack() {
      this.$router.replace({ path: '/' });
    },
    numberOfPlates(wells) {
      let plates = [];
      if (wells == null) return 0;
      wells.forEach(well => {
        if (plates.includes(well.plateNumber) === false) 
          plates.push(well.plateNumber);
      });
      return plates.length;
    },
    async removeOldHealthBleedGroups() {
      let numToRemove = 0;

      const oldGroups = this.archivedHealthBleedGroups.filter(group => {
        let now =  new Date();
        let diffDays = this.daysDiff(now, group.uploadDate);
        if (diffDays > 45) {
          numToRemove ++;
          return false;
        }
        return true;
      });
        
      if (numToRemove > 0) {
        this.archivedHealthBleedGroups = oldGroups;
        await OfflineStorage.setItem('archivedHealthBleedGroups', this.archivedHealthBleedGroups);
      }

      console.log(`Removed ${numToRemove} old Health Bleed Groups.`);
    },
    saveClicked() {
      this.$refs.form.validate();
      setTimeout(() => { // timeout needed to allow validate to complete.
        if(!this.validForm) return;
        if(this.editItem.oldGroupName != null) {  // existing group
          this.showModifyConfirmDialog = true;
        }
        else {
          this.saveGroup(); // new group
        }
      }, 100); 
    },
    async saveGroup() {
      try {
        const hatch = (this.editItem.hatch == 'N/A') ? '' : `_H${this.editItem.hatch}`;
        let groupName = `${this.editItem.farm}${hatch}_${this.editItem.type}_HEALTH`;

        const healthBleedGroup = {
          groupName: groupName,
          farm: this.editItem.farm,
          type: this.editItem.type,
          hatch: this.editItem.hatch,
          batches: this.editItem.batches,
          wells: this.editItem.wells,
          setup: this.editItem.setup
        }

        if (this.editItem.oldGroupName == null) {
          const items = this.healthBleedGroups.filter(x => x.groupName === groupName);
          if (items.length > 0) {
            throw new Error(`Duplicate Group. ${groupName} already exists.`);
          }
          this.healthBleedGroups.push(healthBleedGroup);
        }
        else {
          const items = this.healthBleedGroups.filter(x => x.groupName === groupName);
          if (this.editItem.oldGroupName !== groupName && items.length > 0) {
            throw new Error(`Duplicate Group. ${groupName} already exists.`);
          }
          const itemIndex = this.healthBleedGroups.findIndex(x => x.groupName === this.editItem.oldGroupName);
          this.healthBleedGroups[itemIndex] = healthBleedGroup;
          this.$forceUpdate();
        }
        
        await OfflineStorage.setItem('healthBleedGroups', this.healthBleedGroups);

        this.editItem = {};
        this.closeModifyDialog();
      } catch(error) {
        this.$root.showNoticeError(error.message);
      }
    },
    // toAlphaNumOnly(value) {
    //   if (value == null) return;
    //   value = value.toUpperCase();
    //   value = value.replace(/[^A-Z0-9\s!?]/g,'');
    //   return value;
    // },
    toggleCardDetails(index) {
        this.showDetail[index] = !this.showDetail[index];
      this.$forceUpdate();
    },
    toggleBatchSelection(item) {
      item.selected = !item.selected;
      this.selectedItem = this.batchList.filter((i) => i.selected);
    },
    async uploadHealthBleedGroup() {
      try {
        this.isBusy = true;
        this.showUploadDialog = false;
        await this.removeOldHealthBleedGroups();
      
        let payload = [];
        let numGroupsUploaded = 0;

        const uploadGroup = this.healthBleedGroups.find(e => e.groupName === this.selectedGroup);
        for (let j = 0; j < uploadGroup.wells.length; j++) {
          //var position = uploadGroup.setup == 'Tube' ?  uploadGroup.wells[j].tubeNumber : uploadGroup.wells[j].wellNumber;
          payload.push({
            farmCode: uploadGroup.farm,
            lineCode: uploadGroup.wells[j].line,
            type: uploadGroup.type,
            hatch: uploadGroup.hatch,
            ageNum: parseInt(uploadGroup.wells[j].age),
            location: `${uploadGroup.wells[j].location}`,
            flock: `${uploadGroup.wells[j].flock}`,
            tube: `${uploadGroup.wells[j].tubeNumber}`,
            plate: `${uploadGroup.wells[j].plateNumber}`,
            well : `${uploadGroup.wells[j].wellNumber}`,
            sampleId: uploadGroup.wells[j].sampleId,
            wingband: uploadGroup.wells[j].wingband,
            date: uploadGroup.wells[j].date,
          });
        }

        await gbaApi.postHealthBleed(payload);
        numGroupsUploaded ++;

        //* Add group to archived groups.
        uploadGroup.uploadDate = new Date();
        this.archivedHealthBleedGroups.push(uploadGroup);
        await OfflineStorage.setItem('archivedHealthBleedGroups', this.archivedHealthBleedGroups);

        //* Remove group from active groups.
        const ndx = this.healthBleedGroups.findIndex(s => s.groupName == uploadGroup.groupName);
        this.healthBleedGroups.splice(ndx, 1);
        await OfflineStorage.setItem('healthBleedGroups', this.healthBleedGroups);

        this.isBusy = false;
        if (numGroupsUploaded > 0) this.$root.showNoticeSuccess(`${numGroupsUploaded} Health Bleed Groups uploaded successfully.`);
      } catch(error) {
        console.log(error);
        this.$root.showNoticeError(error.message);
        this.isBusy = false;
      }
    }
  }
}
</script>
<style scoped>
  .side-by-side {
    list-style: none; /* Removes the default bullet points */
    padding-left: 0;
  }
  .side-by-side li {
    display: block;
    float: left;
    width: 155px;
    margin: 2px;
  }
</style>